import anchor from 'theme/anchor'
import button from 'theme/button'
import checkBox from 'theme/checkBox'
import global from 'theme/global'
import heading from 'theme/heading'
import icon from 'theme/icon'
import layer from 'theme/layer'
import paragraph from 'theme/paragraph'
import radioButton from 'theme/radioButton'
import select from 'theme/select'
import text from 'theme/text'
import textInput from 'theme/textInput'
import tab from 'theme/tab'
import tabs from 'theme/tabs'
import formField from 'theme/formField'
import table from 'theme/table'

export const theme = {
  rounding: 4,
  scale: 1,
  spacing: 16,
  name: 'ScPCA-portal',
  anchor,
  button,
  checkBox,
  global,
  heading,
  icon,
  layer,
  paragraph,
  radioButton,
  select,
  text,
  textInput,
  tab,
  tabs,
  formField,
  table
}

export default theme
